import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5422d78a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropDownMenuWrapper" }
const _hoisted_2 = {
  key: 0,
  class: "dropdownMenu"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menuArrow" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("button", {
      class: "dropDownMenuButton flex-container",
      ref: "menu",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openClose && _ctx.openClose(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: "ellipsis-v",
        class: _normalizeClass(["flex-item", _ctx.iconWhite ? 'icon__light' : 'icon__dark'])
      }, null, 8, ["class"])
    ], 512),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _hoisted_3,
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, _ctx.onClickOutside]
  ])
}